import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Reactable from 'reactable';
import { t } from '../../../../modules/infra/i18n';
import * as selector from '../../barbers/selector';

const Report = ({ reportData, tableAutomationId }) => (
  <div>
    <div display-if={!reportData.length}>{t('reports:deposits_report.no_data')}</div>
    <Reactable.Table
      className="c-table-new c-table--small c-table--border c-no-hover"
      data={reportData}
      sortable
      data-automation-id={tableAutomationId}
    />
  </div>
);

const mapStateToProps = state => ({
  reportData: state.reports.depositsReport,
  barbers: selector.getAll(state),
  timezone: state.auth.timezone,
});

Report.propTypes = {
  reportData: PropTypes.array.isRequired,
  timezone: PropTypes.string.isRequired,
  tableAutomationId: PropTypes.string,
};

Report.defaultProps = {
  tableAutomationId: null,
};

export default connect(mapStateToProps)(Report);
